import * as React from 'react';

import { Switch, Route, useRouteMatch } from 'react-router-dom';

import styled from 'styled-components';

import { getWidth } from '@components/styles';

import OnboardingArtist from './onboarding-artist';
import OnboardingPricingPage from './onboarding-pricing';

interface OnboardingPageProps {
  className?: string;
}

const OnboardingPage: React.FC<OnboardingPageProps> = () => {
  const match = useRouteMatch<{ account: string }>();

  return (
    <StyledOnboarding>
      <Switch>
        <OnboardingContainer>
          <Route
            exact
            path={`${match.path}/pricing`}
            render={() => <OnboardingPricingPage />}
          />
          <Route
            path={`${match.path}/artist`}
            render={() => <OnboardingArtist isOnboarding />}
          />
        </OnboardingContainer>
      </Switch>
    </StyledOnboarding>
  );
};

export default OnboardingPage;

const StyledOnboarding = styled.div`
  margin: 0 auto;
  padding-top: 30px;
  min-height: calc(100vh - ${({ theme }) => theme.sizes.navbarMobile});

  @media ${({ theme }) => theme.device.tablet} {
    margin: 0 auto;
    padding-top: 60px;
    min-height: calc(100vh - ${({ theme }) => theme.sizes.navbar});
  }
`;

const OnboardingContainer = styled.div`
  margin: auto;
  max-width: ${getWidth(6)};

  @media ${({ theme }) => theme.device.tablet} {
    max-width: ${getWidth(10)};
  }
`;
